import ApiService from '@/services/api.service'

export default {
  index: () =>
    ApiService().get('/user/lead-sources'),

  store: (name: string) =>
    ApiService().post('/user/lead-sources', { name }),

  update: (id: number, name: string) =>
    ApiService().patch(`/user/lead-sources/${id}`, { name }),

  destroy: (id: number) =>
    ApiService().delete(`/user/lead-sources/${id}`),
}
